import React from 'react';
import PageHeaderText from 'components/base/page-header-text';
import UploadXlsBaseAddonCategory from './upload-xls-base-addon-category';
import useBaseAddonCategoryXlsContext from 'contexts/base-addon-category-xls.context';

const UploadBaseAddonCategory = () => {
  const { setAddons, xlsFile, setXlsFile } = useBaseAddonCategoryXlsContext();
  return (
    <div>
      <PageHeaderText
        title='Add base addon categories via xls'
        description='Create new base addon categories by uploading necessary files'
      />
      <UploadXlsBaseAddonCategory xlsFile={xlsFile} setXlsFile={setXlsFile} setAddons={setAddons} />
    </div>
  );
};

export default UploadBaseAddonCategory;
